export { default } from "bullitttime-embermodelsgochips/adapters/device";
